import React, { useState } from 'react';
import Switch from "react-bootstrap-switch";
import { CardBody,  Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';
import { useForm } from "react-hook-form";

import { ButtonClean, ButtonSearch, } from "../../../components/buttons/buttonsActions";
import { FL_CODE, FL_STATUS } from "../../../components/i18n/formLabels";
import { PH_CODE } from "../../../components/i18n/placeHolders";

export default function ContactCategoryFilters(props) {
    const [status, setStatus] = useState(null);

    const {register, handleSubmit, reset} = useForm();

    const onSubmit = (data, _) => {
        const dataFilter = { ...data };

        if (status !== null)
            dataFilter.status = status;

        props.refreshFiltered(dataFilter);
    };

    const cleanFields = () => {
        setStatus(null);
        reset();
    }

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody className="">
                <Row>
                    <Col md="2">
                        <FormGroup>
                            <Label>{FL_CODE}</Label>
                            <Input
                                type="text"
                                name="code"
                                placeholder={PH_CODE}
                                innerRef={register}
                            />
                        </FormGroup>
                    </Col>

                    <Col md="2">
                        <FormGroup>
                            <Label>{FL_STATUS}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={status}
                                innerRef={register}
                                onChange={(item,val)=>setStatus(val)}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" className="d-flex justify-content-center">
                        <div className="float-right">
                            <ButtonSearch/>
                            <ButtonClean onClick={() => cleanFields()}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}